import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-hourly-unsupported-marketplace-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent],
  template: `
    <app-overlay-layout *transloco="let t" variant="info" [title]="t('overlays.hourly_unsupported_marketplace_title')">
      <p overlayBody>{{ t("overlays.hourly_unsupported_marketplace_reason") }}</p>
      <p overlayBody>{{ t("overlays.hourly_unsupported_marketplace_alternative") }}</p>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HourlyUnsupportedMarketplaceOverlayComponent {
  static readonly rule = OverlayRule.HOURLY_UNSUPPORTED_MARKETPLACE;
}
